import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NutritionComponent } from './nutrition/nutrition.component';
import { AllFoodLogsComponent } from './nutrition/food-logging/all-food-logs.component';
import { MemberDashboardService } from '../member-dashboard.service';
import { ActivatedRoute } from '@angular/router';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-life-style',
  standalone: true,
  imports: [NutritionComponent, AllFoodLogsComponent],
  templateUrl: './life-style.component.html',
  styleUrl: './life-style.component.css'
})
export class LifeStyleComponent {
  @Input() lifeStyle:any;
  @Input() memberId:any;
  @Input() memberName:any;
  @Input() nutritionStartDate:any;
  @Input() nutritionEndDate:any;
  @Input() selectedFoodLogId:any;
  @Input() selectedNutritionType:any;
  @Output() refreshNutrition = new EventEmitter<void>();

  onFoodDeleted() {
    this.refreshNutrition.emit();
  }
}
